// ABOUTME: Component for displaying signal analysis data
// ABOUTME: Shows confirmed signals, unexpected discoveries, and notable absences

import React from 'react';
import { SignalAnalysis as SignalAnalysisType } from '@/types/analysis';

interface SignalAnalysisProps {
  signals: SignalAnalysisType;
}

export const SignalAnalysis: React.FC<SignalAnalysisProps> = ({ signals }) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-md mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Signal Analysis</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {signals.confirmed_positive_signals && signals.confirmed_positive_signals.length > 0 && (
          <div>
            <h4 className="font-medium text-green-700 mb-2">✅ Confirmed Positive Signals</h4>
            <ul className="space-y-2">
              {signals.confirmed_positive_signals.map((signal, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-green-500 mr-2">•</span>
                  <span className="text-sm text-gray-600">{signal}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {signals.confirmed_negative_signals && signals.confirmed_negative_signals.length > 0 && (
          <div>
            <h4 className="font-medium text-red-700 mb-2">❌ Confirmed Negative Signals</h4>
            <ul className="space-y-2">
              {signals.confirmed_negative_signals.map((signal, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-red-500 mr-2">•</span>
                  <span className="text-sm text-gray-600">{signal}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {signals.unexpected_discoveries && signals.unexpected_discoveries.length > 0 && (
          <div>
            <h4 className="font-medium text-purple-700 mb-2">💡 Unexpected Discoveries</h4>
            <ul className="space-y-2">
              {signals.unexpected_discoveries.map((discovery, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-purple-500 mr-2">•</span>
                  <span className="text-sm text-gray-600">{discovery}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {signals.notable_absences && signals.notable_absences.length > 0 && (
          <div>
            <h4 className="font-medium text-yellow-700 mb-2">⚠️ Notable Absences</h4>
            <ul className="space-y-2">
              {signals.notable_absences.map((absence, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-yellow-500 mr-2">•</span>
                  <span className="text-sm text-gray-600">{absence}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
